import { loadEpg, loadEpgArray } from './load-playlist';

const epgMap = new Map();

export async function downloadEpgData(chId, epgId, limit = 1, shift = 0) {
  if (epgId === 'NULL' || !epgId) return [];
  let available = isAvailable(epgId, limit);

  if (available === -1 || !epgId) return [];
  else if (available === 1) return getEpg(epgId, limit, shift);
  else {
    // chId is the stream_id, epgId is the epg_channel_id
    // We need to use stream_id for the Xtream Codes API
    try {
      const result = await loadEpg(chId, limit);
      if (!result) return null;

      const epgListings = result.epg_listings || [];
      if (epgListings && epgListings.length > 0) {
        const convertedData = convertEpgListing(epgListings);

        const dataset = epgMap.has(epgId)
          ? epgMap.get(epgId)
          : { days: {}, data: [] };
        mergeDay(dataset, convertedData, limit);
        epgMap.set(epgId, dataset);
      } else {
        if (epgMap.has(epgId)) {
          if (!epgMap.get(epgId)) return [];
          if (!epgMap.get(epgId).days) epgMap.get(epgId).days = {};
          epgMap.get(epgId).days[limit] = false;
        } else if (limit === 1) epgMap.set(epgId, false);
        else {
          let obj = { days: {}, data: [] };
          obj.days[limit] = false;
          epgMap.set(epgId, obj);
        }
        return [];
      }
    } catch (error) {
      console.warn(`Erro ao carregar EPG para stream_id ${chId}:`, error);
      return [];
    }
  }
}

export function isAvailable(id, day = 1) {
  if (epgMap.has(id)) {
    if (!epgMap.get(id).days || !epgMap.get(id).days[day]) return 0;
    else if (epgMap.get(id).days[day] === false) return -1;
    else if (epgMap.get(id).days[day] === true) return 1;
  }
  return 0;
}

/*
epgs_multiple:[
    {id: "ciao.it", data:[{title:"...."}]}
]
*/

export async function downloadEpgDataFromCategories(channels) {
  const limit = 1;
  let epgIds = Array.from(
    new Set(channels.map((x) => x.epg_channel_id))
  ).filter((x) => x && x !== 'NULL');
  let toDownload = isAvailableArray(epgIds);

  if (toDownload.length === 0) return;
  else {
    // Map epg_channel_id to stream_id for Xtream Codes API
    const epgToStreamMap = {};
    channels.forEach((channel) => {
      if (channel.epg_channel_id && channel.stream_id) {
        epgToStreamMap[channel.epg_channel_id] = channel.stream_id;
      }
    });

    // Get stream_ids for the epg_channel_ids we need to download
    const streamIds = toDownload
      .map((epgId) => epgToStreamMap[epgId])
      .filter(Boolean);

    if (streamIds.length === 0) return;

    const result = await loadEpgArray(streamIds, limit);

    // Map results back to epg_channel_ids
    toDownload.forEach((epgId) => {
      const streamId = epgToStreamMap[epgId];
      if (!streamId) return;

      let data = result[streamId];
      if (data && data.length > 0) {
        data = convertEpgListing(data);
        const dataset = epgMap.has(epgId)
          ? epgMap.get(epgId)
          : { days: {}, data: [] };
        mergeDay(dataset, data, limit);
        epgMap.set(epgId, dataset);
      } else {
        if (epgMap.has(epgId)) {
          if (!epgMap.get(epgId)) {
          }
          if (!epgMap.get(epgId).days) epgMap.get(epgId).days = {};
          epgMap.get(epgId).days[limit] = false;
        } else if (limit === 1) epgMap.set(epgId, false);
        else {
          let obj = { days: {}, data: [] };
          obj.days[limit] = false;
          epgMap.set(epgId, obj);
        }
      }
    });
  }
}

export function isAvailableArray(ids) {
  const toReturn = [];
  ids.forEach((id) => {
    if (!epgMap.has(id)) {
      toReturn.push(id);
    }
  });
  return toReturn;
}

export function getEpg(id, day = 1, shift = 0) {
  if (!id || isAvailable(id, day) !== 1) return [];
  let arr = epgMap.get(id).data.map((x) => ({ ...x }));

  let start = new Date();
  start.setHours(0, 0, 0, 0);
  start = start.getTime() + (day - 1) * 3600000 * 24;

  let end = new Date();
  end.setHours(23, 59, 59, 999);
  end = end.getTime() + (day - 1) * 3600000 * 24;

  if (shift !== 0) {
    arr.forEach((x) => {
      const sh = shift * 60 * 60 * 1000;
      x.start += sh;
      x.end += sh;
    });
  }

  return arr.filter(
    (x) =>
      (x.start >= start && x.start < end) || (x.start < start && x.end > start)
  );
}

export function getSingleEpgNow(id, shift) {
  let arr = getEpg(id, 1, shift);
  return arr.find((x) => x.start <= Date.now() && x.end > Date.now());
}

export function getEpgNow(id, shift) {
  let arr = getEpg(id, 1, shift);
  let end = new Date();
  end.setHours(23, 59, 59, 999);
  return arr.filter(
    (x) =>
      (x.start <= Date.now() && x.end > Date.now()) ||
      (x.start > Date.now() && x.start < end.getTime())
  );
}

function convertEpgListing(data) {
  return data.map((x) => {
    return {
      title: x.title ? decodeURIComponent(escape(atob(x.title))) : x.title,
      description: x.description
        ? decodeURIComponent(escape(atob(x.description)))
        : x.description,
      start: convertTimestamp(x.start || x.start_timestamp),
      end: convertTimestamp(x.stop || x.stop_timestamp),
    };
  });
}

function convertTimestamp(time) {
  if (!time) return 0;
  // Se já é um timestamp Unix, retorna direto
  if (typeof time === 'number') return time;
  // Se é uma string ISO, converte para timestamp
  if (typeof time === 'string') {
    const trimmed = time.trim();
    if (trimmed.length === 0) return 0;

    // Se for uma string numérica, tratar como timestamp Unix (segundos ou milissegundos)
    if (/^-?\d+$/.test(trimmed)) {
      const numeric = Number(trimmed);
      if (Number.isFinite(numeric)) {
        // Valores menores que 1e12 provavelmente estão em segundos
        return numeric < 1e12 ? numeric * 1000 : numeric;
      }
    }

    const date = new Date(trimmed);
    return Number.isNaN(date.getTime()) ? 0 : date.getTime();
  }
  return 0;
}

function mergeDay(dataset, entries, day) {
  dataset.days[day] = true;
  dataset.data = dataset.data.concat(entries);
  dataset.data = dataset.data
    .sort((a, b) => a.start - b.start)
    .filter(
      (x, index, self) => index === self.findIndex((t) => t.start === x.start)
    );
  return dataset;
}
